import { createDictionaryFromDropdownOptions } from "@/utils/utils.js";

export const TrainingStatusEnum = {
  REVIEW: "REVIEW",
  PROGRESS: "PROGRESS",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  LIVE: "LIVE",
  ATTEMPT: "ATTEMPT",
  ERROR: "ERROR",
};

export const TrainingPageEnum = {
  MY_SAVED_DRAFTS: "MY_SAVED_DRAFTS",
  MY_TRAININGS_IN_REVIEW: "MY_TRAININGS_IN_REVIEW",
  FOR_MY_REVIEW: "FOR_MY_REVIEW",
  LIVE: "LIVE",
  REJECTED: "REJECTED",
};

export const trainingStatusOptions = Object.freeze([
  {
    text: "Live",
    value: TrainingStatusEnum.LIVE,
    color: "green",
  },
  {
    text: "Draft",
    value: TrainingStatusEnum.REVIEW,
    color: "blue",
  },
  {
    text: "Approved",
    value: TrainingStatusEnum.APPROVED,
  },
  {
    text: "Rejected",
    value: TrainingStatusEnum.REJECTED,
    color: "red",
  },
  {
    text: "In Review",
    value: TrainingStatusEnum.PENDING,
    color: "yellow",
  },
  {
    text: "Attempt",
    value: TrainingStatusEnum.ATTEMPT,
    color: "green",
  },
  {
    text: "In Progress",
    value: TrainingStatusEnum.PROGRESS,
    color: "green",
  },
  {
    text: "Error",
    value: TrainingStatusEnum.ERROR,
    color: "red",
  },
]);

export const trainingStatusesDictionary = createDictionaryFromDropdownOptions(
  trainingStatusOptions
);

export const trainingStatusesColorsDictionary =
  createDictionaryFromDropdownOptions(trainingStatusOptions, "color");
